import type { StreamDataColumn } from '@squaredup/data-streams';
import Field from 'components/forms/field/Field';
import { Controller } from 'react-hook-form';
import { FormatExpressionEditor } from '../FormatExpressionEditor';

interface FormatExpressionField {
    columnName: string;
    columns: StreamDataColumn[];
    onLoad?: () => void;
}

export const FormatExpressionField: React.FC<FormatExpressionField> = ({ columnName, columns, onLoad }) => {
    return (
        <div className='relative z-10 max-w-4xl'>
            <Field.Label label='Format Expression'>
                <Controller
                    name='formatExpression'
                    render={({ field: { value, onChange } }) => (
                        <FormatExpressionEditor
                            showHint
                            name='formatExpression'
                            value={value || `{{ $['${columnName}'] }}`}
                            onChange={onChange}
                            columns={columns}
                            onLoaded={onLoad}
                        />
                    )}
                />
            </Field.Label>
        </div>
    );
};
